import { useState, useCallback } from "react"
import Chatbot from '../Chatbot/ChatBot'
import '../styles/chatbotwrapper.css'
import { FaceBot } from '../Services/imagesRequest'
import useIframeHeight from '../Hooks/useIframeHeight'

const ChatbotWrapper = () => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  const toggleChat = useCallback(() => {
    setIsChatOpen((prev) => !prev)
  }, [])

  const closeChat = useCallback(() => {
    setIsChatOpen(false)
  }, [])

  useIframeHeight(isChatOpen)

  return (
    <div>
      {isChatOpen && (
        <div className="chatbot-container">
          <Chatbot onCloseChat={closeChat} />
        </div>
      )}

      <button
        className="chatbot-icon"
        onClick={toggleChat}
        aria-label="Abrir chat"
        style={{
          backgroundImage: `url(${FaceBot})`,
        }}
      ></button>
    </div>
  )
}

export default ChatbotWrapper